<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="分类创建" name="first">
      <div>
        <h1>创建一级分类（如：正高级职称、执业医师资格等）</h1>
        <el-form label-width="120px">
          <div v-for="(item, index) in channel" :key="item.index">
            <el-form-item label="unchID(自动生成)">
              <el-input
                :disabled="true"
                v-model="unchID"
                @input="createUnchID"
              ></el-input>
            </el-form-item>
            <el-form-item label="chName">
              <el-input v-model.trim="item.chName"></el-input>
            </el-form-item>
            <el-form-item label="chID">
              <el-input v-model.trim="item.chID"></el-input>
            </el-form-item>
            <el-form-item label="hid">
              <el-input v-model.trim="item.hid"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button
                @click="delChInput(index)"
                type="text"
                size="small"
                plain
                icon="el-icon-delete"
              ></el-button>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="success" plain @click="addChInput"
              >新增一行</el-button
            >
            <el-button type="primary" plain @click="saveCh">点击创建</el-button>
          </el-form-item>
        </el-form>

        <h1>创建二级分类（如：临床医师、主治医师内科等）</h1>
        <el-form label-width="120px">
          <el-form-item label="一级分类">
            <el-select v-model.trim="model.chID" @change="getCourse">
              <el-option
                v-for="item in getchannel"
                :key="item.chID"
                :label="item.chName"
                :value="item.chID"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="uncoID(自动生成)">
            <el-input
              :disabled="true"
              v-model="uncoID"
              @input="createUncoID"
            ></el-input>
          </el-form-item>
          <el-form-item label="coName">
            <el-input v-model.trim="model.coName"></el-input>
          </el-form-item>
          <el-form-item label="coID">
            <el-input v-model.trim="model.coID"></el-input>
          </el-form-item>
          <el-form-item label="oid">
            <el-input v-model.trim="model.oid"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" plain @click="saveCo">点击创建</el-button>
          </el-form-item>
        </el-form>

        <h1>创建三级级分类（如：临床执业医师，放射医学）</h1>
        <el-form label-width="120px">
          <el-form-item label="一级分类">
            <el-select @change="getCourse" v-model.trim="model.chID">
              <el-option
                v-for="item in getchannel"
                :key="item.chID"
                :label="item.chName"
                :value="item.chID"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级分类">
            <el-select v-model.trim="model.coID" @change="getClass">
              <el-option
                v-for="item in course"
                :key="item.coID"
                :label="item.coName"
                :value="item.coID"
              ></el-option>
            </el-select>
          </el-form-item>
          <div>
            <el-form-item label="clName">
              <el-input v-model.trim="model.clName"></el-input>
            </el-form-item>
            <el-form-item label="clID">
              <el-input v-model.trim="model.clID"></el-input>
            </el-form-item>

            <el-form-item label="lid">
              <el-input v-model.trim="model.lid"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button type="primary" plain @click="saveCl">点击创建</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-tab-pane>
    <el-tab-pane label="一级分类" name="second">
      <h3>一级分类</h3>
      <el-table :data="stair" border style="width: 100%">
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="unchID" label="unchID"> </el-table-column>
        <el-table-column prop="chID" label="chID"> </el-table-column>
        <el-table-column prop="chName" label="一级分类"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-edit"
              size="mini"
              @click="chdialog(scope.row._id)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 一级分类修改 -->
      <div v-for="item in ca" :key="item.index">
        <el-dialog title="一级分类修改" :visible.sync="chDialog" width="45%">
          <el-form>
            <!-- <el-form-item label="uncoID(自动生成)">
              <el-input
                :disabled="true"
                v-model="unchID"
                @input="createUnchID"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="chName">
              <el-input v-model="item.chName"> </el-input>
            </el-form-item>
            <el-form-item label="chID">
              <el-input v-model="item.chID"> </el-input>
            </el-form-item>

            <!-- <el-form-item label="clID">
                <el-input v-model="item.clID"> </el-input>
              </el-form-item> -->
            <el-form-item label="hid">
              <el-input :disabled="true" v-model="item.hid"> </el-input>
            </el-form-item>
          </el-form>

          <el-button type="primary" @click="caEdit(item._id)"
            >点击修改</el-button
          >
        </el-dialog>
      </div>
    </el-tab-pane>
    <el-tab-pane label="二级分类" name="third">
      <h3>二级分类</h3>

      <el-table :data="getmover" border style="width: 100%">
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="uncoID" label="uncoID"> </el-table-column>
        <el-table-column prop="chID" label="chID"> </el-table-column>
        <el-table-column prop="caID" label="caID(chID)"> </el-table-column>
        <el-table-column prop="coID" label="coID"> </el-table-column>
        <el-table-column prop="coName" label="二级分类"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-edit"
              size="mini"
              @click="codialog(scope.row._id)"
              >编辑</el-button
            >
            <el-button type="danger" size="mini" @click="coddel(scope.row._id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--  二级分类分页 -->
      <div class="th-page">
        <el-pagination
          @size-change="changeMoverSize"
          @current-change="currentMoverChange"
          :current-page="cPage"
          @prev-click="moverPre"
          @next-click="moverNext"
          background
          :page-sizes="[5, 10, 15, 20]"
          layout="prev, pager, next,total,jumper,sizes"
          :total="moverLength"
        >
        </el-pagination>
      </div>
      <!--  二级分类修改 -->
      <div v-for="item in ca" :key="item.index">
        <el-dialog title="二级分类修改" :visible.sync="coDialog" width="45%">
          <el-form>
            <el-form-item label="chID">
              <el-input v-model="item.chID"> </el-input>
            </el-form-item>
            <el-form-item label="caID">
              <el-input v-model="item.caID"> </el-input>
            </el-form-item>
            <!--  <el-form-item label="uncoID(自动生成)">
              <el-input
                :disabled="true"
                v-model="uncoID"
                @input="createUncoID"
              ></el-input>
            </el-form-item> -->
            <el-form-item label="coID">
              <el-input v-model="item.coID"> </el-input>
            </el-form-item>
            <el-form-item label="coName">
              <el-input v-model="item.coName"> </el-input>
            </el-form-item>
            <!-- <el-form-item label="clID">
                <el-input v-model="item.clID"> </el-input>
              </el-form-item> -->
            <el-form-item label="oid">
              <el-input :disabled="true" v-model="item.oid"> </el-input>
            </el-form-item>
          </el-form>

          <el-button type="primary" @click="caEdit(item._id)"
            >点击修改</el-button
          >
        </el-dialog>
      </div>
    </el-tab-pane>
    <el-tab-pane label="三级分类" name="fourth">
      <h3>三级分类</h3>

      <el-table ref="multipleTable" :data="tertiary" border style="width: 100%">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号"> </el-table-column>
        <el-table-column prop="chID" label="chID"> </el-table-column>
        <el-table-column prop="coID" label="coID"> </el-table-column>
        <el-table-column prop="cbID" label="cbID(coID)"> </el-table-column>
        <el-table-column prop="clID" label="clID"> </el-table-column>
        <el-table-column prop="clName" label="三级分类"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              icon="el-icon-edit"
              size="mini"
              @click="cldialog(scope.row._id)"
              >编辑</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!--  三级分类分页 -->
      <div class="th-page">
        <el-pagination
          @size-change="changeSize"
          @current-change="currentChange"
          :current-page="currentPage"
          @prev-click="thpre"
          @next-click="thnext"
          background
          layout="prev, pager, next,total,jumper,sizes"
          :total="tertiaryLength"
        >
        </el-pagination>
      </div>
      <div>
        <!-- 三级分类修改 -->
        <div v-for="item in ca" :key="item.index">
          <el-dialog title="三级分类修改" :visible.sync="clDialog" width="45%">
            <el-form>
              <el-form-item label="chID">
                <el-input v-model="item.chID"> </el-input>
              </el-form-item>
              <el-form-item label="cbID">
                <el-input v-model="item.cbID"> </el-input>
              </el-form-item>
              <el-form-item label="coID">
                <el-input v-model="item.coID"> </el-input>
              </el-form-item>
              <el-form-item label="clName">
                <el-input v-model="item.clName"> </el-input>
              </el-form-item>
              <el-form-item label="clID">
                <el-input v-model="item.clID"> </el-input>
              </el-form-item>
              <el-form-item label="lid">
                <el-input :disabled="true" v-model="item.lid"> </el-input>
              </el-form-item>
            </el-form>

            <el-button type="primary" @click="caEdit(item._id)"
              >点击修改</el-button
            >
          </el-dialog>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      clDialog: false,
      coDialog: false,
      chDialog: false,
      ca: {},
      unchID: "",
      uncoID: "",
      model: {},
      category: [],
      getchannel: [],
      channel: [{ hid: 1, chID: "", chName: "" }],
      course: [],
      getclass: [],
      tertiary: [],
      tertiaryLength: 0,
      currentPage: 1,
      pageSize: 10,
      getmover: [],
      moverLength: 0,
      cPage: 1,
      pSize: 10,
    };
  },
  methods: {
    //创建和修改一级分类
    async saveCh() {
      //console.log("新增");
      const addch = await this.$http.post("/category/addch", this.channel);
      try {
        if (addch.status === 200) {
          this.$message({
            type: "success",
            message: addch.data.msg,
          });
          this.channel = [
            {
              oid: 1,
              coID: "",
              coName: "",
            },
          ];
        }
      } catch (error) {
        this.$message({
          type: "danger",
          message: error,
        });
      }
      //this.$router.push("/categories/list")
    },
    //创建和修改二级分类
    async saveCo() {
      try {
        const co = {
          chID: this.model.chID,
          coID: this.model.coID,
          coName: this.model.coName,
          oid: this.model.oid,
          uncoID: this.uncoID,
          caID: this.model.chID,
        };
        const addco = await this.$http.post("/category/addco", co);
        if (addco.status === 200) {
          this.$message({
            type: "success",
            message: addco.data.msg,
          });
        } else {
          if (addco.status === 204) {
            this.$message({
              type: "danger",
              message: addco.data.msg,
            });
          }
        }
      } catch (error) {
        this.$message({
          type: "danger",
          message: error,
        });
      }
    },
    async saveCl() {
      try {
        const cl = {
          chID: this.model.chID,
          coID: this.model.coID,
          clID: this.model.clID,
          clName: this.model.clName,
          lid: this.model.lid,
          unchID: this.model.unchID,
        };
        const addcl = await this.$http.post("/category/addcl", cl);
        if (addcl.status === 200) {
          this.$message({
            type: "success",
            message: addcl.data.msg,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getChannel() {
      //console.log(getchannel.data[0].channel);
      try {
        const getchannel = await this.$http.get("/category/getchannel");
        if (getchannel.data) {
          this.getchannel = getchannel.data;
        }
      } catch (error) {
        this.$message({
          type: "danger",
          message: error,
        });
      }
    },
    async coddel(row) {
      try {
        const delco = await this.$http.delete(
          "/category/delcoid?id=" + `${row}`
        );
        if (delco.status === 203) {
          this.$message({
            type: "success",
            message: delco.data.msg,
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCourse(item) {
      try {
        const getcourse = await this.$http.get("/category/getcourse", {
          params: { chID: item },
        });
        this.course = getcourse.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getClass(item) {
      try {
        const getclass = await this.$http.get("/category/getclass", {
          params: { coID: item },
        });
        this.getclass = getclass.data;
      } catch (error) {
        console.log(error);
      }
    },
    async getcategory() {
      try {
        const getcategory = await this.$http.get("/category/getcategory");
        //let stair =[]
        this.category = getcategory.data;
      } catch (error) {
        console.log(error);
      }
    },
    //获取三级分类，分页、跳转等功能
    async getTertiary() {
      try {
        const tertiary = await this.$http.get("/category/gettertiary", {
          params: {
            page: this.currentPage,
            size: this.pageSize,
          },
        });
        //console.log(tertiary.data);
        this.tertiary = tertiary.data.tertiary;
        this.tertiaryLength = tertiary.data.tertiaryCount;
      } catch (error) {
        console.log(error);
      }
    },
    //获取二级分类，分页、跳转等功能
    async getMover() {
      try {
        const getmover = await this.$http.get("/category/getmover", {
          params: {
            page: this.cPage,
            size: this.pSize,
          },
        });
        //console.log(tertiary.data);
        this.getmover = getmover.data.mover;
        this.moverLength = getmover.data.moverCount;
      } catch (error) {
        console.log(error);
      }
    },
    //动态增加ch
    addChInput() {
      try {
        this.channel.push({
          hid: 1,
          chID: "",
          chName: "",
        });
      } catch (error) {
        console.log(error);
      }
    },
    //动态删除ch
    delChInput(index) {
      try {
        this.channel.splice(index, 1);
      } catch (error) {
        console.log(error);
      }
    },
    async chdialog(row) {
      //console.log(row);
      this.chDialog = true;
      this.getcabyid(row);
    },
    async codialog(row) {
      //console.log(row);
      this.coDialog = true;
      this.getcabyid(row);
    },
    async cldialog(row) {
      this.clDialog = true;
      this.getcabyid(row);
      //console.log(row._id);
    },
    async caEdit(row) {
      try {
        const caedit = await this.$http.put(
          "/category/updateca?id=" + `${row}`,
          {
            params: {
              chID: this.ca[0].chID,
              chName: this.ca[0].chName,
              caID: this.ca[0].caID,
              cbID: this.ca[0].cbID,
              coID: this.ca[0].coID,
              coName: this.ca[0].coName,
              clID: this.ca[0].clID,
              clName: this.ca[0].clName,
              lid: this.ca[0].lid,
              oid: this.ca[0].oid,
              hid: this.ca[0].hid,
              //unchID: this.unchID,
              uncoID: this.uncoID,
            },
          }
        );
        if (caedit.status === 201) {
          this.$message({
            type: "success",
            message: caedit.data.msg,
          });
          this.getcategory();
          this.clDialog = false;
          this.coDialog = false;
          this.chDialog = false;
        }
      } catch (error) {
        console.log(error);
      }

      //console.log(caedit);
      //this.updateClass();
    },
    async getcabyid(row) {
      this.createUncoID();
      try {
        const ca = await this.$http.get("/category/getcabyid?id=" + `${row}`);
        this.ca = ca.data;
      } catch (error) {
        console.log(error);
      }
      //console.log(row);

      //console.log(ca);
    },
    //三级分类分页
    async thpre() {
      this.currentPage--;
    },
    async thnext() {
      this.currentPage++;
    },
    async changeSize(size) {
      this.pageSize = size;
    },
    async currentChange(currentPage) {
      this.currentPage = currentPage;
      this.getTertiary(this.currentPage);
    },
    //二级分类
    async moverPre() {
      this.cPage--;
    },
    async moverNext() {
      this.cPage++;
    },
    async changeMoverSize(size) {
      this.pSize = size;
    },
    async currentMoverChange(cPage) {
      this.cPage = cPage;
      this.getMover(this.cPage);
    },
    //生成unchID
    createUnchID() {
      this.unchID = Date.now();
    },
    //生成uncoID
    createUncoID() {
      this.uncoID = Date.now() + 6;
      console.log(this.uncoID);
    },
  },
  created() {
    this.getChannel();
    //this.getClass();
    this.getcategory();
    this.getTertiary();
    this.getMover();
    this.createUnchID();
    this.createUncoID();
  },
  computed: {
    stair: function () {
      return this.category.filter((item) => item.hid === 1);
    },
    /* mover: function () {
      return this.category.filter((item) => item.oid === 2);
    }, */
    /*  tertiary: function () {
      return this.category.filter((item) => item.lid === 3);
    }, */
  },
};
</script>

<style scoped>
.category .ca-left {
  background: #999;
  width: 280px;
  line-height: 50px;
  height: 50px;
}
.th-page {
  margin-top: 15px;
  text-align: right;
}
</style>
